export default {"src":"/_next/static/media/apple_store.840ef5ab.svg","height":100,"width":268,"blurWidth":0,"blurHeight":0};